import { ProductScreenshot } from 'components/ProductScreenshot';
import ImgReplayConfigLight from "../../../../contents/images/docs/session-replay/enable-session-replay-in-project-settings.png";
import * as React from 'react';
export default {
  ProductScreenshot,
  ImgReplayConfigLight,
  React
};